import React, { useEffect, KeyboardEvent, ChangeEvent, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import Swal from 'sweetalert2';
import Menu from '../../Components/Menu';
import { API_Get_Category, API_Get_Kind, API_Update_Kind } from '../../Utils/api';

interface ItemStruct {
    id_kind: string
    id_category: string
    name_kind: string
}

const Kind_Edit = () => {

    const history = useHistory();

    const param = useParams<{
        id: string
    }>();

    const [Data, setData] = useState<ItemStruct>({
        id_kind: param.id,
        id_category: '',
        name_kind: ''
    });
    
    const [Error, setError] = useState({
        id_category: false,
        name_kind: false
    });


    const [Category, setCategory] = useState([]);

    const onEnter = (event : KeyboardEvent<HTMLInputElement>) : void => {
        event.key === 'Enter' && onSubmitData()
    }

    const onSubmitData = () : void => {
        if (
            CheckEmpty('id_category', Data.id_category) &&
            CheckEmpty('name_kind', Data.name_kind)
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'คำเตือน',
                text: 'คุณต้องการที่จะแก้ไขข้อมูล ใช่ หรือ ไม่?',
                timer: 5000,
                timerProgressBar: true,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'ใช่',
                cancelButtonText: 'ไม่',
            }).then(result => {
                if (result.value) {
                    PostData();
                }
            });
        }
    }

    const PostData = () : void => {
        API_Update_Kind(Data).then(res => {
            Swal.fire({
                icon: res.status ? 'success' : 'error',
                title: res.status ? 'สำเสร็จ' : 'เกิดข้อผิดพลาด',
                text: res.message,
                timer: 5000,
                timerProgressBar: true,
            }).then(() => {
                if (res.status) {
                    history.push('/kind');
                }
            });
        }).catch(() => {
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถเชื่อมต่อฐานข้อมูลได้',
                timer: 5000,
                timerProgressBar: true,
            });
        });
    }

    const CheckEmpty = (id : string, value : string) : boolean => {
        if (value !== '') {
            setError(preState => ({
                ...preState,
                [id]: false
            }));
            return true;
        } else {
            setError(preState => ({
                ...preState,
                [id]: false
            }));
            document.getElementById(id)?.focus();
            return false;
        }
    }

    const onChangeData = (event : ChangeEvent<any>) : void => {
        setData(prestate => ({
            ...prestate,
            [event.target.id]: event.target.value
        }))
    }

    const Get_Data = () => {
        API_Get_Kind(param.id).then(res => {
            setData(res.data[0]);
        }).catch(() => {
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถเชื่อมต่อฐานข้อมูลได้',
                timer: 5000,
                timerProgressBar: true,
            }).then(() => {
                history.push('/kind');
            })
        });
    }

    const Get_Category = () => {
        API_Get_Category('').then(res => {
            setCategory(res.data);
        }).catch(() => {
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'ไม่สามารถเชื่อมต่อฐานข้อมูลได้',
                timer: 5000,
                timerProgressBar: true,
            }).then(() => {
                history.push('/kind');
            })
        });
    }

    useEffect(() => {
        Get_Category();
        Get_Data();
    }, []);

    return (
        <div className="is-flex" style={{gap: '10px'}}>
            <Menu />
            <div className="p-2 container">
                <h5 className="subtitle is-5 mt-3 mb-3">จัดการกับหมวดหมู่ / แก้ไขข้อมูลหมวดหมู่</h5>
                <div className="card">
                    <div className="card-content">
                        <div className="field">
                            <label className="label">ประเภท</label>
                            <div className="control">
                                <select value={Data.id_category} defaultValue="" id="id_category" onChange={onChangeData} className={`input ${Error.id_category ? 'is-danger' : ''}`}>
                                    <option disabled value="">กรุณาเลือกประเภท</option>
                                    {
                                        Category.map((item, index) => (
                                            <option key={index} value={item['id_category']}>{item['name_category']}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">ชื่อหมวดหมู่</label>
                            <div className="control">
                                <input value={Data.name_kind} onKeyPress={onEnter} onChange={onChangeData} id="name_kind"
                                autoFocus className={`input ${Error.name_kind ? 'is-danger' : ''}`} type="text" placeholder="ชื่อหมวดหมู่" />
                            </div>
                        </div>
                        <button onClick={() => onSubmitData()} className="button is-link is-fullwidth">แก้ไขข้อมูล</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Kind_Edit;